export enum PlaidProducts {
  Assets = 'assets',
  Auth = 'auth',
  Balance = 'balance',
  BalancePlus = 'balance_plus',
  Beacon = 'beacon',
  CraBaseReport = 'cra_base_report',
  CraIncomeInsights = 'cra_income_insights',
  CraPartnerInsights = 'cra_partner_insights',
  CreditDetails = 'credit_details',
  DepositSwitch = 'deposit_switch',
  Employment = 'employment',
  Identity = 'identity',
  IdentityMatch = 'identity_match',
  IdentityVerification = 'identity_verification',
  Income = 'income',
  IncomeVerification = 'income_verification',
  Investments = 'investments',
  InvestmentsAuth = 'investments_auth',
  Layer = 'layer',
  Liabilities = 'liabilities',
  PaymentInitiation = 'payment_initiation',
  ProcessorIdentity = 'processor_identity',
  ProcessorPayments = 'processor_payments',
  Profile = 'profile',
  RecurringTransactions = 'recurring_transactions',
  Signal = 'signal',
  StandingOrders = 'standing_orders',
  Statements = 'statements',
  Transactions = 'transactions',
  Transfer = 'transfer',
}

export enum PlaidAccountTypes {
  Credit = 'credit',
  Depository = 'depository',
  Investment = 'investment',
  Loan = 'loan',
  Other = 'other',
}

export enum PlaidAccountSubtypes {
  _401a = '401a',
  _401k = '401k',
  _403B = '403B',
  _457b = '457b',
  _529 = '529',
  Auto = 'auto',
  Brokerage = 'brokerage',
  Business = 'business',
  CashIsa = 'cash isa',
  CashManagement = 'cash management',
  Cd = 'cd',
  Checking = 'checking',
  Commercial = 'commercial',
  Construction = 'construction',
  Consumer = 'consumer',
  CreditCard = 'credit card',
  CryptoExchange = 'crypto exchange',
  Ebt = 'ebt',
  EducationSavingsAccount = 'education savings account',
  FixedAnnuity = 'fixed annuity',
  Gic = 'gic',
  HealthReimbursementArrangement = 'health reimbursement arrangement',
  HomeEquity = 'home equity',
  Hsa = 'hsa',
  Ira = 'ira',
  Isa = 'isa',
  Keogh = 'keogh',
  Lif = 'lif',
  LifeInsurance = 'life insurance',
  LineOfCredit = 'line of credit',
  Lira = 'lira',
  Loan = 'loan',
  Lrif = 'lrif',
  Lrsp = 'lrsp',
  MoneyMarket = 'money market',
  Mortgage = 'mortgage',
  MutualFund = 'mutual fund',
  NonCustodialWallet = 'non-custodial wallet',
  NonTaxableBrokerageAccount = 'non-taxable brokerage account',
  Null = 'null',
  Other = 'other',
  OtherAnnuity = 'other annuity',
  OtherInsurance = 'other insurance',
  Overdraft = 'overdraft',
  Paypal = 'paypal',
  Payroll = 'payroll',
  Pension = 'pension',
  Prepaid = 'prepaid',
  Prif = 'prif',
  ProfitSharingPlan = 'profit sharing plan',
  Rdsp = 'rdsp',
  Recurring = 'recurring',
  Resp = 'resp',
  Retirement = 'retirement',
  Rewards = 'rewards',
  Rlif = 'rlif',
  Roth = 'roth',
  Roth401k = 'roth 401k',
  Rrif = 'rrif',
  Rrsp = 'rrsp',
  SafeDeposit = 'safe deposit',
  Sarsep = 'sarsep',
  Savings = 'savings',
  SepIra = 'sep ira',
  SimpleIra = 'simple ira',
  Sipp = 'sipp',
  StockPlan = 'stock plan',
  Student = 'student',
  Tfsa = 'tfsa',
  ThriftSavingsPlan = 'thrift savings plan',
  Trust = 'trust',
  Ugma = 'ugma',
  Utma = 'utma',
  VariableAnnuity = 'variable annuity',
}
